import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IUser } from '@interfaces/IUser';
import { ITokens } from '@myStore/auth/auth.state';
import { Store } from '@ngrx/store';
import jwt_decode from 'jwt-decode';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private _http: HttpClient, private _store: Store) {}

  getTokenValidity(token: string): Observable<{ detail: string }> {
    const url = `${environment.baseUrl}api/v1/users/reset-password/?token=${token}`;
    return this._http.get<{ detail: string }>(url);
  }

  login(user: IUser): Observable<ITokens> {
    const url = `${environment.baseUrl}api/v1/users/sign-in/`;
    return this._http.post<ITokens>(url, user);
  }

  refreshToken(): Observable<ITokens> {
    const url = `${environment.baseUrl}api/v1/users/refresh-token/`;
    return this._http.post<ITokens>(url, { refresh: this.getToken('refresh') });
  }

  logout(): Observable<null> {
    const url = `${environment.baseUrl}api/v1/users/logout/`;
    return this._http.post<null>(url, { refresh: this.getToken('refresh') });
  }

  getToken(type: string): string {
    const tokens = localStorage.getItem('tokens');

    if (tokens) {
      return JSON.parse(tokens)[type];
    }
    return '';
  }

  resetPasswordRequest(user: {
    email: string;
  }): Observable<{ detail: string; token: string }> {
    const url = `${environment.baseUrl}api/v1/users/reset-password/`;
    return this._http.post<{ detail: string; token: string }>(url, user);
  }

  resetPassword(passwordData: {
    password: string;
    confirm_password: string;
    confirmed_token: string;
  }): Observable<{ detail: string }> {
    const url = `${environment.baseUrl}api/v1/users/reset-password/`;
    return this._http.put<{ detail: string }>(url, passwordData);
  }

  updateTokens(userTokens: ITokens) {
    if (this.getToken('refresh')) {
      const refreshToken = this.getToken('refresh');
      localStorage.setItem(
        'tokens',
        JSON.stringify({ ...userTokens, refresh: refreshToken })
      );
    } else {
      localStorage.setItem('tokens', JSON.stringify(userTokens));
    }
  }

  tokenIsExpiry(token: string): boolean {
    const user: IUser = jwt_decode(token);
    if (user.exp) {
      return Math.floor(new Date().getTime() / 1000) + 20 >= user.exp;
    } else {
      return true;
    }
  }
}
